import React, {useEffect} from 'react';
import PropTypes from 'prop-types';
import {uid} from 'react-uid';
import {LayoutGroup, motion, useAnimation} from 'motion/react';
import {Grid, Paper, Text} from '@tenancy.nz/ui';

function PropertyList({items = [], loading = false, renderItem}) {
  const controls = useAnimation();

  useEffect(() => {
    const animate = async () => {
      await controls.start('hidden');
      controls.start('show');
    };
    animate();
  }, [items, controls]);

  const containerAnimation = {
    hidden: {opacity: 0},
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
      },
    },
  };

  const itemAnimation = {
    hidden: {scale: 0.9, translateY: -20, opacity: 0},
    show: {scale: 1, translateY: 1, opacity: 1},
  };

  return (
    <LayoutGroup>
      <motion.div
        variants={containerAnimation}
        initial="hidden"
        animate={controls}>
        <Grid container spacing={6} alignItems="stretch">
          {!loading &&
            items.map(item => (
              <Grid item xs={12} sm={6} md={4} key={uid(item)}>
                <motion.div
                  variants={itemAnimation}
                  style={{height: '100%'}}
                  layout>
                  {renderItem(item)}
                </motion.div>
              </Grid>
            ))}
          {!loading && items.length === 0 && (
            <Grid item xs={12}>
              <motion.div variants={itemAnimation}>
                <Paper inset="xlarge" elevate={false} sx={{bgcolor: 'grey.50'}}>
                  <Text align="center" weight="500" color="priamry">
                    No properties found matching your search criteria.
                  </Text>
                </Paper>
              </motion.div>
            </Grid>
          )}
        </Grid>
      </motion.div>
    </LayoutGroup>
  );
}

PropertyList.propTypes = {
  /**
   *
   */
  items: PropTypes.array,

  /**
   *
   */
  loading: PropTypes.bool,

  /**
   *
   */
  renderItem: PropTypes.func.isRequired,
};

export default PropertyList;
